$(function(){
  function autosize() {
    var el = this;
    setTimeout(function () {
      el.style.cssText = 'height:auto; padding:14px 18px';
      el.style.cssText = 'height:' + el.scrollHeight + 'px';
      var dialogBox = $('.dialogue-messages');
      dialogBox.scrollTop(dialogBox[0].scrollHeight);
    }, 0);
  }

  var ww = $(window).width();
  $('.announcing').slick({
    prevArrow: '<button type="button" class="slider-bt slider-bt--prev"></button>',
    nextArrow: '<button type="button" class="slider-bt slider-bt--next"></button>',
    fade: true,
    adaptiveHeight: true
  });
  $('.toggle-menu').click(function (e) {
    e.preventDefault();
    $('html, body').toggleClass('menu-open');
    $('.sidebar, .header-sidebar').toggleClass('sidebar-open');
    $('.main-menu__item--dropdown--open').removeClass('main-menu__item--dropdown--open').find('.main-menu-dropdown').hide();
  });
  $('.main-menu__item--has-dropdown .main-menu__link').click(function (e) {
    e.preventDefault();
    $(this).parent().toggleClass('main-menu__item--dropdown--open').find('.main-menu-dropdown').slideToggle(200);
  });

  $('.tabs').rkTabs({
    activeCaptionClass: 'blue-menu__item--active',
    setHash: true,
    startonHash: true
  });

  $('.show-question-form').click(function (e) {
    e.preventDefault();
    $.fancybox.open({ src: '#new_ticket_create' });
  });
  $('.accordion').rkAccordion();

  var responciveTables = document.querySelectorAll('.responcive-tbl');
  Array.prototype.forEach.call(responciveTables, function (el, i) {
    var headertext = [],
      headers = el.querySelectorAll("th"),
      tablerows = el.querySelectorAll("th"),
      tablebody = el.querySelector("tbody");
    for (var i = 0; i < headers.length; i++) {
      var current = headers[i];
      headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
    }
    for (var i = 0, row; row = tablebody.rows[i]; i++) {
      for (var j = 0, col; col = row.cells[j]; j++) {
        col.setAttribute("data-th", headertext[j]);
      }
    }
  });

  $('.friend--dialog-selector').click(function (e) {
    e.preventDefault;
    var dialogBox = $('.dialogue-messages');
    $(this).addClass('friend--dialog-active').siblings().removeClass('friend--dialog-active');
    $('.empty-dialog-message').hide();
    $('.dialog-form-box').show();
    $('.dialog-title').show();
    $('.chat-page').addClass('chat-page--dialog-opened');
    dialogBox.show();
    dialogBox.scrollTop(dialogBox[0].scrollHeight);
  });

  $('.show-add-dialog').click(function (e) {
    e.preventDefault();
    $('.friend-list--dialogues').hide();
    $('.create-dialog-box').css('display', 'flex');
    $('.chat-page').removeClass('chat-page--dialog-opened');
  });

  $('.tmp-close-create-dialog').click(function (e) {
    e.preventDefault();
    $('.friend-list--dialogues').show();
    $('.create-dialog-box').hide();
  })

  /* var headertext = [],
    headers = document.querySelectorAll("#miyazaki th"),
    tablerows = document.querySelectorAll("#miyazaki th"),
    tablebody = document.querySelector("#miyazaki tbody");

  for (var i = 0; i < headers.length; i++) {
    var current = headers[i];
    headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
  }
  for (var i = 0, row; row = tablebody.rows[i]; i++) {
    for (var j = 0, col; col = row.cells[j]; j++) {
      col.setAttribute("data-th", headertext[j]);
    }
  } */

  // $('.responcive-tbl').each(function () {
  //   var headertext = [],
  //     headers = $(this).find('th'),
  //     tablebody = $(this).find('tbody');
  //   for (var i = 0; i < headers.length; i++) {
  //     var current = headers[i];
  //     headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
  //   }
  //   for (var i = 0, row; row = tablebody.rows[i]; i++) {
  //     for (var j = 0, col; col = row.cells[j]; j++) {
  //       col.setAttribute("data-th", headertext[j]);
  //     }
  //   }
  // })

  
  if(ww > 767) {
    $(document).on('click', '.has-popup', function (e) {
      $message = $(this).next('.popup-dropdown');
      if ($message.css('display') != 'block') {
        $message.show();
        $(document).bind('click.openPopup', function (e) {
          if ($(e.target).closest('.popup-dropdown').length == 0) {
            $message.hide();
            $(document).unbind('click.openPopup');
          }
        });
      } else {
        $message.hide();
        $(document).unbind('click.openPopup');
      }
      e.preventDefault();
    });
    
    var fields = document.querySelectorAll('.adaptive-textarea');
    Array.prototype.forEach.call(fields, function (el, i) {
      el.addEventListener('keydown', autosize);
    });
  }
  
})